module.exports = __webpack_public_path__ + "img/shuttle_run_card.05211f35.svg";